import { render, staticRenderFns } from "./AnalisiRischiView.vue?vue&type=template&id=4bf8e346&scoped=true"
import script from "./AnalisiRischiView.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiView.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRischiView.vue?vue&type=style&index=0&id=4bf8e346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8e346",
  null
  
)

export default component.exports